import { ComplianceGauge } from "./ComplianceGauge";
import { OsDistribution } from "./OsDistribution";
import { TopPolicies } from "./TopPolicies";
import { EmptyApiState } from "./EmptyApiState";
import { useDeviceUpdateRows } from "@/hooks/useSoftwareUpdates";
import { AlertCircle, BarChart3, Clock, Gauge } from "lucide-react";

export function OverviewTab() {
  const { stats, familyDistribution, isLoading } = useDeviceUpdateRows();

  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-3">
        <ComplianceGauge
          compliance={stats.compliance}
          upToDate={stats.upToDate}
          total={stats.total}
        />
        <OsDistribution data={familyDistribution} />
        <TopPolicies />
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <EmptyApiState
          title="OS readiness banner"
          description="Major OS release readiness (e.g. iOS 27) will appear here once the Apple GDMF feed is wired up."
          icon={<AlertCircle className="h-5 w-5" aria-hidden="true" />}
        />
        <EmptyApiState
          title="BSI / RSR adoption"
          description="Rapid Security Response adoption percentage needs a backend rollup."
          icon={<Gauge className="h-5 w-5" aria-hidden="true" />}
        />
        <EmptyApiState
          title="Update lag"
          description="Average time to install released updates across the fleet."
          icon={<Clock className="h-5 w-5" aria-hidden="true" />}
        />
        <EmptyApiState
          title="Deadline pressure"
          description="Devices approaching enforced installation deadlines."
          icon={<BarChart3 className="h-5 w-5" aria-hidden="true" />}
        />
      </div>

      {isLoading && (
        <p className="text-xs text-muted-foreground">Loading fleet…</p>
      )}
    </div>
  );
}

export default OverviewTab;
